import { Select } from "@primer/react";
import { IThamSoHeThongUpdateActiveStatus } from "../../model/request/category/IThamSoHeThongUpdateActiveStatus";
import { IThamSoHeThongUpdateRequest } from "../../model/request/category/IThamSoHeThongUpdateRequest";
import { apiClient } from "../apiClient";

export const THAM_SO_HE_THONG_ENDPOINT = 'tham-so-he-thong';
export const thamSoHeThongApi = {
    SelectAll: () => apiClient.get(`${THAM_SO_HE_THONG_ENDPOINT}/phan-he/12`),
    UpdateActiveStatus: (request: IThamSoHeThongUpdateActiveStatus) => apiClient.patch(`${THAM_SO_HE_THONG_ENDPOINT}/active`,request),
    UpdateThamSo: (request: IThamSoHeThongUpdateRequest) => apiClient.put(`${THAM_SO_HE_THONG_ENDPOINT}`, request)
};
